/**
 * [KA] Cart drawer — takeover module.
 *
 * The custom drawer (sections/ka-cart-drawer.liquid) claims id="cart-drawer".
 * It lives in the header group, which is parsed BEFORE the core drawer render
 * in layout/theme.liquid, so every id lookup (the header trigger's
 * on:click="#cart-drawer/toggle", aria-controls, header-actions.js aria sync,
 * Shopify.actions.openCart, theme-drawer session restore) resolves to OUR
 * drawer with zero attribute rewriting — Horizon resolves declarative event
 * targets at click time (assets/component.js).
 *
 * This module's only jobs:
 *  1. Detach the core drawer section node (kills its auto-open listener and
 *     its cart-items-component's per-mutation refetch) — reversibly.
 *  2. Theme-editor lifecycle: open on select, close on deselect, re-neutralize
 *     after re-render, hand the drawer back to core when the section is
 *     removed — all without page reloads.
 */

const CORE_SECTION_ID = 'shopify-section-cart-drawer-section';
const OURS = 'theme-drawer[data-ka-cart-drawer]';

let detachedCore = null;

function neutralizeCore() {
  const ours = document.querySelector(OURS);
  const core = document.getElementById(CORE_SECTION_ID);
  if (!ours || !core || core.contains(ours)) return;
  detachedCore = core;
  core.remove();
}

function restoreCore() {
  if (detachedCore && !document.getElementById(CORE_SECTION_ID)) {
    document.body.appendChild(detachedCore);
  }
  detachedCore = null;
}

neutralizeCore();

if (window.Shopify?.designMode) {
  const isOurs = (el) => el instanceof Element && Boolean(el.querySelector?.(OURS) || el.matches?.(OURS));
  const drawer = () => document.querySelector(OURS);
  let selected = false;

  const open = () =>
    customElements.whenDefined('theme-drawer').then(() => {
      const d = drawer();
      if (d && !d.hasAttribute('open')) d.open();
    });
  const close = () => {
    const d = drawer();
    if (d && d.hasAttribute('open')) d.close();
  };

  document.addEventListener('shopify:section:select', (e) => {
    if (isOurs(e.target)) {
      selected = true;
      open();
    }
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    if (isOurs(e.target)) {
      selected = false;
      close();
    }
  });
  document.addEventListener('shopify:block:select', (e) => {
    if (isOurs(e.target)) {
      selected = true;
      open();
    }
  });
  // Setting change re-renders the section (drops [open]) — re-neutralize and
  // re-open if the merchant is editing it.
  document.addEventListener('shopify:section:load', (e) => {
    if (isOurs(e.target)) {
      neutralizeCore();
      if (selected) open();
    }
  });
  // Section removed in the editor — give the cart back to core, no reload.
  document.addEventListener('shopify:section:unload', (e) => {
    if (isOurs(e.target)) restoreCore();
  });
}
